import { createEndpoint } from '@/shared/models/api';
import { MaterialInformation } from '@/app/api/morgan-thermal/material';

export const getMaterial = createEndpoint<MaterialInformation>(({fetch}) => (id: MaterialInformation['id']) => fetch(`/Material/Get/${id}`));